module.exports = __webpack_public_path__ + "static/img/background.9c1a3d58.svg";